module.exports = __webpack_public_path__ + "img/quiz-skate-4.a478063d.jpg";